import {
  APISRC
} from '../constants/Fetch'

export function deleteData(src, id, token) {
  let siteHeaders = new Headers({
    // eslint-disable-next-line
    'X-CSRFToken': document.cookie.replace(/(?:(?:^|.*;\s*)csrftoken\s*\=\s*([^;]*).*$)|^.*$/, "$1")
  });
  return fetch(APISRC + src + id + '/?token=' + token, {
    method: 'DELETE',
    headers: siteHeaders
  })
  .then(response => {
    return response.ok;
  })
}


// WEBPACK FOOTER //
// ./src/utils/DeleteRequest.js